const resizeEcharts = function (echart, myChart) {
    const elementResizeDetectorMaker = require('element-resize-detector')// 引入监听dom变化的组件
    const erd = elementResizeDetectorMaker()
    // 监听id为echart的元素 大小变化
    erd.listenTo(echart, function (element) {
        // const width = element.offsetWidth
        const height = element.offsetHeight
        myChart.resize()
    })
}

export {
    resizeEcharts,
}